export default function getInitials(name) {
  return name
    .split(" ")
    .filter((v) => v !== "")
    .map((item) => item.substring(0, 1))
    .join("")
    .toUpperCase();
}
